export async function fetchAPI(method: string = "GET", endpoint: string, body?: any | null) {
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");
    const headers = {};
    // const headers = {
    //     "Content-Type": "application/json",
    // };

    if (accessToken) {
        Object.assign(headers, { "Authorization": `Bearer ${accessToken}` });
    }

    const params: RequestInit = {
        method,
        // credentials: "include",
        // mode: "cors",
        headers,
    };
    if (method === "POST" && body) {
        params.body = JSON.stringify(body);
    }
   return fetch(`${process.env.REACT_APP_API_URL}${endpoint}`, params);
}